module.exports = __webpack_public_path__ + "static/media/cris-logo-50.811dce4a.png";